import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend, setInteractionMode } from 'vee-validate'
// eslint-disable-next-line
import { required, email, numeric, alpha_spaces, required_if } from 'vee-validate/dist/rules'
import validatePassword from '@/services/validation/password'
import validatePhone from '@/services/validation/validate-phone'

// These are tested within form elements on LoginForm and RegisterForm
export function initialiseValidations () {
  // vee-validate validation rules
  extend('email', email)
  extend('numeric', numeric)
  extend('required', required)
  extend('alpha_spaces', alpha_spaces)
  extend('required_if', required_if)

  // Custom validation rules
  extend('password', value => {
    return validatePassword(value)
  })
  extend('phone', value => {
    return validatePhone(value)
  })
  extend('code', value => {
    return value.length === 6
  })

  extend('valid_name', value => {
    const regex = /^([A-Za-zÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿĀāĂăĄąĆćĈĉĊċČčĎďĐđĒēĔĕĖėĘęĚěĜĝĞğĠġĢģĤĥĦħĨĩĪīĬĭĮįİıĲĳĴĵĶķĸĹĺĻļĽľĿŀŁłŃńŅņŇňŉŊŋŌōŎŏŐőŒœŔŕŖŗŘřŚśŜŝŞşŠšŢţŤťŦŧŨũŪūŬŭŮůŰűŲųŴŵŶŷŸŹźŻżŽžſ\s\u{0027}\u{0060}\u{00b4}\u{2018}\u{2019}'_\-.])+$/iu
    return regex.test(value) && value.length >= 2
  })

  // Global components for validation
  Vue.component('ValidationProvider', ValidationProvider)
  Vue.component('ValidationObserver', ValidationObserver)

  // Validates after blur, or live validation if already validated once
  setInteractionMode('eager')
}
